import { useUserStore, usePersonnelStore } from "~/stores"

export const DOMAIN = {
    admin: {
        model: "App\\Models\\Laravel\\User",
        store: () => useUserStore(),
        home: "admin.clients", // Redirects to first active company
        login: "auth.login.admin",
        prefix: "admin.",
    },
    manager: {
        model: "App\\Models\\Lola\\Personnel",
        store: () => usePersonnelStore(),
        home: "manager.dashboard",
        login: "auth.login.manager",
        prefix: "manager.",
    },
    space: {
        model: "App\\Models\\Lola\\Client",
        home: "space.home",
        login: "auth.login.space",
        prefix: "space.",
    },
}

export const findModuleFromModel = (model) => {
    for (const key in DOMAIN) {
        if (DOMAIN[key].model === model) {
            return DOMAIN[key].module
        }
    }
    return null
}

export const findStoreFromModel = (model) => {
    for (const key in DOMAIN) {
        if (DOMAIN[key].model === model) {
            return DOMAIN[key].store
        }
    }
    return null
}

export const getSubdomain = window.location.hostname.split(".")[0]

export const isAdminDomain = getSubdomain === "admin"
